/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pilot_Ended_Contact_HintInputs */



/**
* | output |
* | --- |
* | "Or write directly to hello@wundo.ai" |
*
* @param {Pilot_Ended_Contact_HintInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const pilot_ended_contact_hint = /** @type {((inputs?: Pilot_Ended_Contact_HintInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pilot_Ended_Contact_HintInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Of mail rechtstreeks naar hello@wundo.ai")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ou écrivez directement à hello@wundo.ai")
	return /** @type {LocalizedString} */ ("Or write directly to hello@wundo.ai")
});